const Dashboard = () => {
    return <div>Finance Dashboard</div>
}

export default Dashboard;